import { availabilityApi } from '@/infrastructure/Configuration'

const baseUrl = `${availabilityApi}/exchange-rates`

export default class ExchangeRatesService {
  constructor (httpClient) {
    this.httpClient = httpClient
  }

  async getExchangeRates (sourceCurrency) {
    const url = baseUrl + '/' + sourceCurrency
    const response = await this.httpClient.get(url)
    return response.data.exchangeRates.filter(exchangeRate => (exchangeRate.currencyCode !== 'LBP' && exchangeRate.currencyCode !== 'TRL') || exchangeRate.currencyCode === sourceCurrency)
  }
}
